/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Login_Error_AuthInputs */



/**
* | output |
* | --- |
* | "Authentication error: {error}" |
*
* @param {Login_Error_AuthInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_error_auth = /** @type {((inputs: Login_Error_AuthInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_AuthInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur d'authentification : ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error de autenticación: ${i?.error}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Erro de autenticação: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore di autenticazione: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Authentication error: ${i?.error}`)
});